import React from 'react';

const Radio = ({
  fieldName,
  label,
  hideLabel = false,
  allowNull = false,
  allowBlank = false,
  value = '',
  options = [],
  errors = [],
  helpText = '',
  noneChoice = 'None',
  pk = null,
  style = {},
}) => {
  return (
    <div className={`radio-form-group form-group ${style.class} ${errors.length > 0 ? 'has-error is-invalid' : ''}`}>
    {(allowNull || allowBlank) && (
      <label className="radio-group">
        <input
          id={"empty_option"}
          className="form-check-input"
          type="radio"
          name={fieldName}
          value=""
          defaultChecked={!value}
        />
        {noneChoice}
      </label>
    )}

    {options.map((option) => (
      <label
        className={`radio-group radio ${errors.length > 0 ? 'has-error is-invalid' : ''}`}
        key={option.id}
        htmlFor={option.id}
      >
        <input
          id={option.id}
          className="form-check-input"
          type="radio"
          name={fieldName}
          value={option.id}
          defaultChecked={option.id === value}
        />
        {option.label}
      </label>
    ))}
  </div>
  );
};

export default Radio;
